module.exports = __webpack_public_path__ + "static/media/netlify.92b6c228.png";